import React from 'react';

const ChipPlace = (props) => {
  return (
    <div className='relative mb-5 w-max '>
      <div
        className={`flex items-center h-8 px-4 py-1 text-lg font-normal text-white rounded-3xl max-w-225px overflow-hidden overflow-ellipsis whitespace-nowrap`}
        style={{ backgroundColor: `${props.color}` }}
      >
        {props.label}
      </div>
    </div>
  );
};

export default ChipPlace;
